import { type IconComponentBaseProps } from '@/components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type CheckCircleProps = IconComponentBaseProps;

export const CheckCircle = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: CheckCircleProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.82772 5.51665L2.72736 4.41616C2.66175 4.35063 2.57929 4.31708 2.47997 4.3155C2.38074 4.314 2.29678 4.34755 2.22809 4.41616C2.15949 4.48484 2.12518 4.56805 2.12518 4.66579C2.12518 4.76353 2.15949 4.84674 2.22809 4.91542L3.528 6.21533C3.61366 6.30091 3.71357 6.3437 3.82772 6.3437C3.94188 6.3437 4.04179 6.30091 4.12745 6.21533L6.76279 3.57999C6.82832 3.51438 6.86187 3.43192 6.86345 3.33261C6.86495 3.23337 6.8314 3.14941 6.76279 3.08072C6.69411 3.01212 6.61089 2.97782 6.51316 2.97782C6.41542 2.97782 6.33221 3.01212 6.26353 3.08072L3.82772 5.51665ZM4.50083 9C3.87841 9 3.29337 8.8819 2.74571 8.64568C2.19805 8.40947 1.72168 8.08891 1.31661 7.68399C0.911526 7.27907 0.590803 6.8029 0.354434 6.25547C0.118145 5.70805 0 5.12317 0 4.50083C0 3.87841 0.118105 3.29337 0.354316 2.74571C0.590526 2.19805 0.911092 1.72168 1.31601 1.31661C1.72093 0.911526 2.19711 0.590803 2.74453 0.354434C3.29195 0.118145 3.87683 0 4.49917 0C5.12159 0 5.70663 0.118105 6.25429 0.354316C6.80195 0.590526 7.27832 0.911092 7.6834 1.31601C8.08847 1.72093 8.4092 2.19711 8.64557 2.74453C8.88186 3.29195 9 3.87683 9 4.49917C9 5.12159 8.8819 5.70663 8.64568 6.25429C8.40947 6.80195 8.08891 7.27832 7.68399 7.6834C7.27907 8.08847 6.8029 8.4092 6.25547 8.64557C5.70805 8.88186 5.12317 9 4.50083 9Z"
      fill={fill}
    />
  </svg>
);
